import { actionTypeCommon } from "../types";

const initialState = {
    // loading: false,
    error: null,
    getLanguagesData: [],
    getCountryData: [],
    getTimeZonesData: [],
    getWebsiteLanguageData: [],
    getCurrencyData: [],
    getPhysicianServiceData: [],
};

const reducerCommon = (state = initialState, action) => {
    switch (action.type) {
        case actionTypeCommon.GET_LANGUAGES_REQUEST:
            return {
                ...state,
                // loading: true,
                error: null,
            };
        case actionTypeCommon.GET_LANGUAGES_SUCCESS:
            return {
                ...state,
                // loading: false,
                getLanguagesData: action.payload,
                error: null,
            };
        case actionTypeCommon.GET_LANGUAGES_FAILURE:
            return {
                ...state,
                // loading: false,
                error: action.payload,
            };
        case actionTypeCommon.GET_COUNTRY_REQUEST:
            return {
                ...state,
                // loading: true,
                error: null,
            };
        case actionTypeCommon.GET_COUNTRY_SUCCESS:
            return {
                ...state,
                // loading: false,
                getCountryData: action.payload,
                error: null,
            };
        case actionTypeCommon.GET_COUNTRY_FAILURE:
            return {
                ...state,
                // loading: false,
                error: action.payload,
            };
        case actionTypeCommon.GET_TIME_ZONES_REQUEST:
            return {
                ...state,
                // loading: true,
                error: null,
            };
        case actionTypeCommon.GET_TIME_ZONES_SUCCESS:
            return {
                ...state,
                // loading: false,
                getTimeZonesData: action.payload,
                error: null,
            };
        case actionTypeCommon.GET_TIME_ZONES_FAILURE:
            return {
                ...state,
                // loading: false,
                error: action.payload,
            };

        case actionTypeCommon.GET_WEBSITE_LANGUAGE_DATA_REQUEST:
            return {
                ...state,
                // loading: true,
                error: null,
            };
        case actionTypeCommon.GET_WEBSITE_LANGUAGE_DATA_SUCCESS:
            return {
                ...state,
                // loading: false,
                getWebsiteLanguageData: action.payload,
                error: null,
            };
        case actionTypeCommon.GET_WEBSITE_LANGUAGE_DATA_FAILURE:
            return {
                ...state,
                // loading: false,
                error: action.payload,
            };

        case actionTypeCommon.GET_CURRENCY_REQUEST:
            return {
                ...state,
                // loading: true,
                error: null,
            };
        case actionTypeCommon.GET_CURRENCY_SUCCESS:
            return {
                ...state,
                // loading: false,
                getCurrencyData: action.payload,
                error: null,
            }

        case actionTypeCommon.GET_CURRENCY_FAILURE:
            return {
                ...state,
                // loading: false,
                error: action.payload,
            }
        case actionTypeCommon.GET_PHYSICIAN_SERVICE_REQUEST:
            return {
                ...state,
                // loading: true,
                error: null,
            };
        case actionTypeCommon.GET_PHYSICIAN_SERVICE_SUCCESS:
            return {
                ...state,
                // loading: false,
                getPhysicianServiceData: action.payload,
                error: null,
            };
        case actionTypeCommon.GET_PHYSICIAN_SERVICE_FAILURE:
            return {
                ...state,
                // loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default reducerCommon;
